import React, { useEffect, useRef } from 'react';
import { Box, Typography } from '@mui/material';

function AdContainer({ id, height = '90px', width = '728px', label = 'Advertisement', slot, format = 'auto', responsive = true }) {
  const adRef = useRef(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    // Only push ad once, after a short delay to ensure container has width
    if (slot && !pushedRef.current && adRef.current) {
      const timer = setTimeout(() => {
        try {
          if (window.adsbygoogle) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            pushedRef.current = true;
          }
        } catch (e) {
          // Silently ignore AdSense errors (common during development)
          if (process.env.NODE_ENV === 'development') {
            console.warn('AdSense warning:', e.message);
          }
        }
      }, 100);

      return () => clearTimeout(timer);
    }
  }, [slot]);

  return (
    <Box
      id={id}
      className="ad-container"
      sx={{
        background: '#fafafa',
        border: '1px solid #e0e0e0',
        padding: '2px 4px',
        margin: 0,
        textAlign: 'center',
        overflow: 'hidden',
      }}
    >
      <Typography
        className="ad-label"
        sx={{
          fontSize: '7px',
          color: '#aaa',
          textTransform: 'uppercase',
          letterSpacing: '0.3px',
          margin: 0,
          lineHeight: 1,
        }}
      >
        {label}
      </Typography>
      <Box
        ref={adRef}
        className="ad-placeholder"
        sx={{
          height: height,
          maxHeight: height,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          margin: 0,
          padding: 0,
          position: 'relative',
        }}
      >
        {slot ? (
          <>
            <style dangerouslySetInnerHTML={{__html: `
              .ad-${id} {
                display: inline-block !important;
                width: ${width} !important;
                height: ${height} !important;
                max-height: ${height} !important;
                max-width: ${width} !important;
                overflow: hidden !important;
              }
              @media (max-width: 768px) {
                .ad-${id} {
                  width: 320px !important;
                  height: ${height} !important;
                  max-width: 320px !important;
                }
              }
            `}} />
            <ins
              className={`adsbygoogle ad-${id}`}
              style={{ display: 'inline-block', width: width, height: height, maxWidth: width }}
              data-ad-client="ca-pub-1768446265734594"
              data-ad-slot={slot}
            />
          </>
        ) : (
          <Box
            sx={{
              background: '#f0f0f0',
              border: '1px dashed #ccc',
              height: height,
              maxHeight: height,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999',
              fontSize: '10px',
              width: '100%',
              overflow: 'hidden',
            }}
          >
            <span>Ad Space</span>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default AdContainer;
